export class SuspicionRequest { 
    public idSuspicion: number;
    public suspicionName: string;
    public listIdHealthUnit: number[] = [];
    public isActive: boolean;
    public isDefault: boolean;
}